/**
 * @fileoverview 미납신고 취소 인증 API 함수
 * 미납신고 취소 처리를 위한 인증 요청을 수행하고 응답 데이터를 검증하는 API
 */

import { apiInstance } from "@core/api/axios/apiInstance";
import { nonpaidReportCancelSchema, type GetNonpaidReportCancelType, type ReqNonpaidReportCancelType } from "@features/helpdesk/model/getNonpaidReportCancelModel";
import { parseSchema } from "@core/model/parseSchema";

/**
 * 미납신고 취소 인증을 요청하는 API 함수
 *
 * 서버에 미납신고 취소를 위한 인증 요청을 보내고, 응답 데이터의 유효성을 검사합니다.
 * 검증에 성공하면 타입이 보장된 데이터를 반환하고, 실패하면 null을 반환합니다.
 *
 * @async
 * @function getNonpaidReportCancel
 * @param {ReqNonpaidReportCancelType} params - 미납신고 취소 인증 요청 파라미터
 * @param {SelfCertQType} params.q - 본인인증 질문 타입
 * @param {number} params.complaintID - 신고 ID
 * @returns {Promise<GetNonpaidReportCancelType | null>}
 *   - 성공 시: 검증된 미납신고 취소 결과 데이터
 *   - 실패 시: null
 *
 * @throws {Error} 네트워크 에러나 HTTP 에러가 발생한 경우
 */
export const getNonpaidReportCancel = async (params: ReqNonpaidReportCancelType): Promise<GetNonpaidReportCancelType | null> => {
  // API 인스턴스를 통해 GET 요청 수행
  // '/nonpaidreport/cancel/auth/verify' 엔드포인트로 인증 요청
  const res = await apiInstance.get(`nonpaidreport/cancel/auth/verify`, { params });

  // 응답 데이터를 스키마로 검증하고 결과 처리
  return parseSchema<GetNonpaidReportCancelType>({
    schema: nonpaidReportCancelSchema,
    rawData: res.data,
  });
};
